import { useState, useRef } from "react";
import { FormRow, FormRowSelect, SubmitBtn, FormRowSelectId } from "../";
import Wrapper from "../../assets/wrappers/DashboardFormPage";
import {
  Form,
  useSubmit,
  useOutletContext,
  useLocation,
} from "react-router-dom";
import { Loading } from "../../components";
import { useAllCampaignsContext } from "../../pages/AllCampaigns";

const CampaignSearchContainer = () => {
  const submit = useSubmit();
  const { user } = useOutletContext();
  const [isLoading, setIsLoading] = useState(false);
  const { maintenanceCompanies } = useAllCampaignsContext();
  const { search } = useLocation();
  const qs = new URLSearchParams(search);

  // useRef לשמירת מזהה ה־timeout בין קריאות
  const debounceTimeout = useRef(null);

  // useRef להפניה ל־<Form>, כשנרצה fallback
  const formRef = useRef(null);

  // Debounce לחיפוש (search) – 1100ms
  const handleSearchChange = (e) => {
    const formElement = e.currentTarget.form;

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(async () => {
      setIsLoading(true);
      try {
        await submit(formElement);
      } catch (err) {
        // טיפול בשגיאה אם צריך
      } finally {
        setIsLoading(false);
      }
    }, 1500); // 800 + 300
  };

  // Debounce לשדות select (status, maintenanceCompany, isGlobal) – 100ms
  const handleSelectChange = (e) => {
    let formElement;

    if (e && e.target) {
      formElement = e.currentTarget.form;
    } else {
      formElement = formRef.current;
    }

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(async () => {
      setIsLoading(true);
      try {
        await submit(formElement);
      } catch (err) {
        // טיפול בשגיאה אם צריך
      } finally {
        setIsLoading(false);
      }
    }, 100);
  };

  return (
    <Wrapper>
      {/* משייכים ref ל־Form */}
      <Form className="form" ref={formRef}>
        <h5 className="form-title">חיפוש קמפיין</h5>
        {isLoading && <Loading />}

        <div className="form-center">
          {/* שדה חיפוש: debounce 1100ms */}
          <FormRow
            type="search"
            name="search"
            labelText="חיפוש"
            defaultValue={qs.get("search") || ""}
            handleChange={handleSearchChange}
          />

          {/* שדה סטטוס: debounce 100ms */}
          <FormRowSelect
            name="status"
            labelText="מצב"
            list={["הכל", "ממתין", "פעיל", "הושלם"]}
            defaultValue={qs.get("status") || "הכל"}
            handleChange={handleSelectChange}
          />

          <FormRowSelect
            name="workOnSaturday"
            labelText="מוצג בשבת"
            list={["הכל", "כן", "לא"]}
            defaultValue={qs.get("workOnSaturday") || "הכל"}
            handleChange={handleSelectChange}
          />

          {/* שדה חברת אחזקה (id-only): debounce 100ms */}
          {user?.role === "admin" && (
            <FormRowSelectId
              name="maintenanceCompany"
              labelText="חברת אחזקה"
              list={[{ _id: "הכל", name: "הכל" }, ...maintenanceCompanies]}
              idField="_id"
              displayField="name"
              defaultValue={qs.get("maintenanceCompany") || "הכל"}
              handleChange={handleSelectChange}
            />
          )}

          {/* שדה isGlobal: debounce 100ms */}
          <FormRowSelect
            name="isGlobal"
            labelText="פרסום בכל המסכים"
            list={["הכל", "כן", "לא"]}
            defaultValue={qs.get("isGlobal") || "הכל"}
            handleChange={handleSelectChange}
          />

          {/* כפתור ניקוי הסינון מבצע בעצם מיזוג מחדש */}
          <SubmitBtn formBtn buttonText="ניקוי סינון" />
        </div>
      </Form>
    </Wrapper>
  );
};

export default CampaignSearchContainer;
